(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"]) return;
  try {
    
  class BundleBuilder extends HTMLElement {
    constructor() {
      super();

      this.totalAmount = 0;

      this.currency = this.dataset.currency || "USD";
      this.locale = this.dataset.locale || "en-US";

      this.cartItems = [];
      this.tier = 0;
      this.tiers = [];
    }

    connectedCallback() {
      this.querySelectorAll("fieldset input[type='radio']").forEach(input => {
        input.addEventListener("change", this.handleVariantChange.bind(this));
      });

      this.querySelectorAll("button[data-add-to-fake-cart]").forEach(btn => {
        btn.addEventListener("click", this.addToFakeCart.bind(this));
      });

      this.tiers = this.getTiers(this.dataset.tiers);
      this.setTier();
    }

    formatMoney(value) {
      const amount = value / 100;
      const formatted = amount.toLocaleString(this.locale, {
        style: 'currency',
        currency: this.currency,
        trailingZeroDisplay: "stripIfInteger"
      });
      // If you really want to mimic money_without_trailing_zeros, you can
      // strip .00, but in many cases just returning formatted is fine.
      return formatted;
    }

    getTiers(tiers) {
      let acc = 0;
      const tiersObj = tiers.split("\n").map((tier, index) => {
        const [base, percentage] = tier.split("|").map(value => +value);
        return {
          base: base * 100,
          percentage,
          diff: index === 0 ? base * 100 : (base - +tiers.split("\n")[index - 1].split("|")[0]) * 100,
          previous: index === 0 ? 0 : +tiers.split("\n")[index - 1].split("|")[0] * 100,
          previousPercentage: index === 0 ? 0 : +tiers.split("\n")[index - 1].split("|")[1],
        };
      });
      return tiersObj;
    }

    setTier() {
      this.tier = this.tiers.filter(tier => this.totalAmount < tier.base)[0];

      if (this.tier) {
        this.querySelectorAll("span.percentage-off").forEach(item => {
          item.classList.remove("hidden");
          item.textContent = `${this.tier.percentage}% off`;
        });

        if (this.tier.previousPercentage) {
          this.querySelector(".current-percentage-off").textContent = `${this.tier.previousPercentage}% off`;
        } else {
          this.querySelector(".current-percentage-off").textContent = "";
        }
      } else {
        this.tier = this.tiers[this.tiers.length - 1];
        this.querySelectorAll("span.percentage-off").forEach(item => {
          item.classList.add("hidden");
        });
        this.querySelector(".current-percentage-off").textContent = `${this.tier.percentage}% off`;
      }

      console.log("TIER:", this.tier);

      const amountToNextTier = this.tier.base - this.totalAmount;
      const percentageToNextTier = (this.tier.diff - amountToNextTier) * 100 / this.tier.diff;
      const discountedAmount = this.totalAmount - this.totalAmount * (this.tier.previousPercentage / 100);
      this.querySelector(".bar").style.width = `${percentageToNextTier}%`;

      this.querySelector(".amount-to-next-tier").textContent = this.formatMoney(amountToNextTier);

      this.querySelector(".checkout-button span.discounted-amount").textContent = this.formatMoney(discountedAmount);
      if (this.tier.previousPercentage) {
        this.querySelector(".checkout-button span.total-amount").textContent = this.formatMoney(this.totalAmount);
        this.querySelector(".checkout-button span.savings").textContent = "Save " + this.formatMoney(this.totalAmount - discountedAmount);
        this.querySelector(".checkout-button span.savings").classList.remove("hidden");
      } else {
        this.querySelector(".checkout-button span.total-amount").textContent = "";
        this.querySelector(".checkout-button span.savings").classList.add("hidden");
      }

      console.log(this.totalAmount, amountToNextTier, percentageToNextTier);
    }

    handleVariantChange(e) {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });

      this.currentVariant = this.getVariantsData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });

      const imgSrc = e.target.closest(".product").querySelector("img").src.split("&")[0];
      const imgSrcset = e.target.closest(".product").querySelector("img").srcset.split("&")[0];

      e.target.closest(".product").querySelector("img").src = e.target.closest(".product").querySelector("img").src.replace(imgSrc, this.currentVariant.featured_image.src);
      e.target.closest(".product").querySelector("img").srcset = e.target.closest(".product").querySelector("img").srcset.replaceAll(imgSrcset, this.currentVariant.featured_image.src);

      e.target.closest(".product").querySelector("button[data-add-to-fake-cart]").dataset.variantId = this.currentVariant.id;
    }

    getVariantsData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    addToFakeCart(e) {
      const variantId = +e.currentTarget.dataset.variantId;

      let isInCart = false;

      this.cartItems.forEach(item => {
        if (item.variantId === variantId) {
          item.qty++;
          isInCart = true;
          const fakeProduct = document.querySelector(`.fake-cart [data-variant-id="${variantId}"]`);
          fakeProduct.querySelector("quantity-input input").value = item.qty;
          fakeProduct.querySelector("quantity-input span").textContent = item.qty;
        }
      });

      if (isInCart) {
        this.calculateTotals();
        return;
      }

      const productCard = e.currentTarget.closest(".product").cloneNode(true);
      productCard.dataset.variantId = variantId;
      productCard.querySelector("variant-radios")?.remove();
      productCard.querySelector("button[data-add-to-fake-cart]").remove();
      productCard.querySelector("quantity-input").classList.remove("hidden");

      productCard.querySelector(".icon.icon-close").classList.remove("hidden");
      productCard.querySelector(".icon.icon-close").addEventListener("click", this.removeFromFakeCart.bind(this));

      const unitPrice = +productCard.querySelector(".price").dataset.price;

      productCard.querySelector("quantity-input input").addEventListener("change", this.handleQuantities.bind(this));


      if (!this.cartItems.length) {
        this.querySelector(".fake-cart").innerHTML = "";
        this.querySelector(".spend-save-more").classList.remove("hidden");
      }

      this.querySelector(".fake-cart").append(productCard);

      this.cartItems.push({
        variantId,
        unitPrice,
        qty: 1
      });

      this.calculateTotals();
      this.querySelector(".checkout-button").classList.remove("hidden");
    }

    removeFromFakeCart(e) {
      const variantId = +e.currentTarget.closest(".product").dataset.variantId;
      this.cartItems = this.cartItems.filter(item => item.variantId !== variantId);

      e.currentTarget.closest(".product").remove();

      if (!this.cartItems.length) {
        this.querySelector(".spend-save-more").classList.add("hidden");
        this.querySelector(".fake-cart").innerHTML = `<p class="w-full h-20 lg:h-40 col-span-2 flex items-center justify-center">Add products to build your bundle</p>`;
        this.querySelector(".checkout-button").classList.add("hidden");
      }

      this.calculateTotals();
    }

    handleQuantities(e) {
      const variantId = +e.currentTarget.closest(".product").dataset.variantId;
      const qty = +e.currentTarget.value;

      this.cartItems.map(item => {
        if (item.variantId === variantId) {
          item.qty = qty;
        }
        return item;
      });

      this.calculateTotals();
    }

    calculateTotals() {
      const totals = this.cartItems.reduce((acc, cur) => acc + cur.unitPrice * cur.qty, 0);
      this.totalAmount = totals;
      this.setTier();
    }
  }

  customElements.define("bundle-builder", BundleBuilder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
const thumbs = document.querySelector(".thumbnails");

const params = {
  breakpoints: {
    watchSlidesProgress: true,
    320: {
      slidesPerView: 5,
      spaceBetween: 16
    },
    768: {
      slidesPerView: 6,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 16
    },
    1280: {
      slidesPerView: 6,
      spaceBetween: 20
    }
  }
};

Object.assign(thumbs, params);

thumbs.initialize();

  } catch(e) { console.error(e); }
})();
})();
